/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-11 16:30:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-01 10:51:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/ColorPickerWidthTitle/index.tsx
 */
/**
 *  ColorPicker Wrapped with title
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

import ColorPicker from 'src/components/ColorPicker/ColorPicker';

import css from './css.less';
const ColorPickerWidthTitle = (props) => {
  const { title, subtitle, color, onChange, multi, options } = props;
  return (
    <div className={css.container}>
      <div className={css.title}>{title}</div>
      <div className={css.subTitle}>{subtitle}</div>
      <ColorPicker
        onChange={onChange}
        color={color}
        {...(multi ? {} : { options })}
        multi={multi}
      />
    </div>
  );
};
export default ColorPickerWidthTitle;
